import SubcategoryPageLayout from "@/components/SubcategoryPageLayout";

const subcategories: Record<string, { heading: string; subtitle: string; categoryKey: string }> = {
  "pergole": { heading: "Pergole Bioclimatiche", subtitle: "Lamelle orientabili per comfort e protezione tutto l'anno.", categoryKey: "outdoor-pergole" },
  "tende-sole": { heading: "Tende da Sole", subtitle: "Protezione solare retrattile, resistente e su misura.", categoryKey: "outdoor-tende-sole" },
  "gazebi": { heading: "Gazebi", subtitle: "Spazi living all'aperto, eleganti e funzionali.", categoryKey: "outdoor-gazebi" },
  "tettoie": { heading: "Tettoie", subtitle: "Coperture architettoniche per ingressi e terrazze.", categoryKey: "outdoor-tettoie" },
  "arredi": { heading: "Arredi Esterni", subtitle: "Complementi per un risultato completo e coordinato.", categoryKey: "outdoor-arredi" },
  "chiusure": { heading: "Chiusure Verticali", subtitle: "Privacy e protezione dal vento e dal sole.", categoryKey: "outdoor-chiusure" },
};

export default subcategories;
